import { View } from "../view";
import { BaseApp } from "../app/index";

export enum ModalColor
{
    GREEN = 'green',
    BLUE = 'blue',
    ORANGE = 'orange',
    RED = 'red'
}

export enum ModalResultType
{
    OK = 'ok',
    YES = 'yes',
    NO = 'no',
    CANCEL = 'cancel',
    SAVE = 'save'
}

export enum ModalIcon
{
    ERROR = 'im im-warning'
}

export interface ModalResult<T extends Object>
{
    type: ModalResultType;
    data: T;
}

export interface ModalOptions
{
    title?: string;
    message?: string;
    iconClass?: string;
    color?: ModalColor;
}

export abstract class BaseModal extends View
{
    public result: ModalResult<any>;

    public get defaults(): ModalOptions
    {
        return {
            color: ModalColor.BLUE
        }
    }

    constructor(options?: ModalOptions)
    {
        super(options);
    }

    public showIn(app: BaseApp): PromiseLike<ModalResult<any>>
    {
        return app.modals.show(this).then(() => {
            return this.result
        });
    }

    public close(resultType = ModalResultType.OK, data = undefined): PromiseLike<void>
    {

        this.result = {
            type: resultType,
            data: data
        }

        return new Promise<void>((resolve, reject) =>
        {
            let closeTimeout = setTimeout(() => {
                super.close().then(resolve);
            }, 500);

            this.element.addEventListener('transitionend', () =>
            {
                clearTimeout(closeTimeout);
                super.close().then(resolve);
            });

            this.element.classList.remove('visible');
        });
    }

    public afterRender(): PromiseLike<void>
    {
        let visibleTimeout;
        let transitionCallback = e => {
            this.element.removeEventListener('transitionend', transitionCallback);
            clearTimeout(visibleTimeout);
            this.afterVisible();
        }
        this.element.addEventListener('transitionend', transitionCallback);
        visibleTimeout = setTimeout(transitionCallback, 250);

        setTimeout(() => {
            this.element.classList.add('visible');
        }, 50);

        return super.afterRender();
    }

    /**
     * Called after the modal is fully visible (transition has ended)
     */
    protected afterVisible() {}
}

export interface ModalConstructor
{
    new (data?: any) : BaseModal;
}

